export default __webpack_public_path__ + "static/media/logo2.cc074055.png";